<template>
  <v-row>
    <v-col cols="12"> {{ title }} </v-col>
    <v-col cols="12" v-for="(i, index) in model">
      <v-container fluid class="py-1 px-0">
        <v-row>
          <v-col
            v-if="!readonly"
            @click="removeItem(index)"
            cols="1"
            style="display: flex; align-items: center; justify-content: center"
          >
            <v-tooltip v-if="!markDeleted && !hideRemove" :text="$t('basics.delete')">
              <template v-slot:activator="{ props }">
                <span v-bind="props">
                  <v-icon class="icon-transparency">mdi-minus</v-icon>
                </span></template
              ></v-tooltip
            >

            <v-tooltip
              v-else-if="markDeleted && i.deleted && !hideRemove"
              :text="$t('basics.publish', { type: $t('basics.affiliation') })"
            >
              <template v-slot:activator="{ props }">
                <span v-bind="props">
                  <v-icon class="icon-transparency">mdi-eye-off</v-icon>
                </span></template
              ></v-tooltip
            >

            <v-tooltip
              v-else-if="!hideRemove"
              :text="$t('basics.hide', { type: $t('basics.affiliation') })"
            >
              <template v-slot:activator="{ props }">
                <span v-bind="props">
                  <v-icon class="icon-transparency" color="primary">mdi-eye</v-icon>
                </span>
              </template>
            </v-tooltip>
          </v-col>
          <v-col
            :cols="items2 ? 10 : mainCols"
            style="
              display: flex;
              align-items: center;
              background-color: rgb(var(--v-theme-background));
            "
          >
            <slot name="display-title" :item="i"> </slot>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
    <v-col>
      <v-container fluid class="py-1 px-0" v-if="!readonly">
        <v-row>
          <v-col
            cols="1"
            style="display: flex; align-items: center; justify-content: center"
          >
            <v-icon class="icon-transparency">mdi-plus</v-icon>
          </v-col>

          <v-col
            :cols="countCols"
            style="display: flex; align-items: center"
            v-if="hasCount && reverse"
          >
            <v-text-field
              variant="outlined"
              flat
              :rules="[]"
              v-model="count"
              class="hideDetails dashed"
              type="number"
              :min="1"
            >
            </v-text-field>
          </v-col>
          <v-col
            :cols="mainCols"
            style="display: flex; align-items: center; flex-grow: 1"
            class="pl-0"
          >
            <v-combobox
              variant="outlined"
              flat autocomplete="off"
              :rules="[]"
              v-model="newItem"
              :items="itemList"
              class="hideDetails dashed"
              :item-title="(item) => this.getItemTitle(item)"
              :multiple="hasMutliple"
              @update:search="fetchItems1"
            >
              <template v-slot:item="{ props, item }">
                <div v-bind="props" class="pa-2 hoverable">
                  <slot name="display-list" :item="item"> </slot>
                </div>
              </template>

              <template v-slot:selection="{ props, item }">
                <div v-bind="props">
                  <span v-if="typeof itemTitle == 'string'">
                    {{ item.raw[itemTitle] }}</span
                  >

                  <span v-else>
                    <span v-for="i in itemTitle" class="mr-1">{{ item.raw[i] }}</span>
                  </span>
                </div>
              </template>
            </v-combobox>
          </v-col>
          <v-col
            v-if="items2"
            :cols="mainCols"
            style="display: flex; align-items: center; flex-grow: 1"
            class="px-0"
          >
            <v-combobox
              variant="outlined" autocomplete="off"
              flat
              :rules="[]"
              v-model="newItem2"
              :items="item2List"
              :item-title="item2Title"
              class="hideDetails dashed"
              :multiple="false"
              @update:search="fetchItems2"
            >
              <template v-slot:item="{ props, item }">
                <div v-bind="props" class="pa-2 hoverable">
                  <slot name="display-list" :item="item"> </slot>
                </div>
              </template>
            </v-combobox>
          </v-col>

          <v-col
            :cols="countCols"
            style="display: flex; align-items: center"
            v-if="!items2 && hasCount && !reverse"
          >
            <v-text-field
              variant="outlined"
              flat
              :rules="[]"
              v-model="count"
              class="hideDetails dashed"
              type="number"
              :min="1"
            >
            </v-text-field>
          </v-col>

          <v-spacer v-if="!items2" />

          <v-col cols="auto" style="display: flex; align-items: center" v-if="!readonly">
            <v-btn
              :disabled="!newItem || (items2 && !newItem2)"
              flat
              large
              block
              class="primaryButton squareButton"
              @click="addItem()"
            >
              <v-icon size="xx-large">mdi-check</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "fancyComboboxComponent",

  props: {
    title: {},
    items: {},
    items2: { default: undefined }, //double combobox
    model: {
      default: [],
    },
    itemTitle: { default: "name" },
    item2Title: { default: "name" },
    //when using 2 comboboxes subobjects are needed!
    subObject: {},
    subObject2: {},
    hasCount: { default: false },
    reverse: { default: false },
    hasMutliple: { default: false },
    readonly: { default: false },
    allowDoubleSelection: { default: false }, //can same item be picked multiple times
    markDeleted: { default: false }, //instead of deleting, mark deleted instead
    hideRemove: { default: false }, // option to hide the minus in front of items
  },

  emits: ["update", "refetch1", "refetch2"],

  data() {
    return {
      newItem: undefined,
      newItem2: undefined,
      count: 1,
    };
  },

  watch: {
    count() {
      if (this.newItem && this.newItem.count < this.count) {
        this.count = this.newItem.count;
      }

      if (this.count < 1) {
        this.count = 1;
      }
    },
  },

  computed: {
    itemList() {
      if (!this.items) {
        return [];
      }
      if (!this.model) {
        return;
      }

      let result = JSON.parse(JSON.stringify(this.items));

      if (this.allowDoubleSelection) {
        return result;
      }

      for (let i = 0; i < result.length; i++) {
        for (let j = 0; j < this.model.length; j++) {
          if (this.subObject) {
            if (this.model[j][this.subObject].id == result[i].id) {
              result.splice(i, 1);
              i--;
              break;
            }
          } else {
            if (this.model[j].id == result[i].id) {
              result.splice(i, 1);
              i--;
              break;
            }
          }
        }
      }

      return result;
    },
    item2List() {
      if (!this.items2) {
        return [];
      }
      if (!this.model) {
        return;
      }

      return JSON.parse(JSON.stringify(this.items2));
    },
    mainCols() {
      if (this.hasCount) {
        return 7;
      }

      if (this.items2) {
        return "auto";
      }

      switch (this.$vuetify.display.name) {
        case "xs":
          return 8;
        case "sm":
          return 8;
        case "md":
          return 9;
        case "lg":
          return 9;
        case "xl":
          return 9;
        case "xxl":
          return 9;
        default:
          return 9;
      }
    },
    countCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 2;
        case "sm":
          return 2;
        case "md":
          return 2;
        case "lg":
          return 2;
        case "xl":
          return 2;
        case "xxl":
          return 2;
        default:
          return 2;
      }
    },
  },

  methods: {
    getItemTitle(item) {
      if (typeof this.itemTitle == "string") {
        return item[this.itemTitle];
      }

      let result = "";
      for (let i = 0; i < this.itemTitle.length; i++) {
        result += item[this.itemTitle[i]];
      }

      return result;
    },
    fetchItems1() {
      this.$emit("refetch1", this.newItem);
    },
    fetchItems2() {
      this.$emit("refetch2", this.newItem2);
    },
    addItem() {
      if (typeof this.newItem == "object") {
        if (!this.items2 || typeof this.newItem2 == "object") {
          let temp = {};

          if (this.subObject) {
            temp[this.subObject] = this.newItem;
          } else {
            temp = this.newItem;
          }

          if (this.newItem2) {
            if (this.subObject2) {
              temp[this.subObject2] = this.newItem2;
            }
          }

          if (this.hasCount) {
            if (this.newItem.count < this.count) {
              temp["count"] = this.newItem.count;
            } else if (this.count < 1) {
              temp["count"] = 1;
            } else {
              temp["count"] = this.count;
            }
          }

          this.model.push(temp);

          this.newItem = undefined;
          this.newItem2 = undefined;
          this.count = 1;

          this.$emit("update");
        }
      }
    },
    removeItem(index) {
      if (!this.markDeleted) {
        this.model.splice(index, 1);
        this.$emit("update");
      } else {
        this.model[index].deleted = !this.model[index].deleted;
        this.$emit("update");
      }
    },
  },
};
</script>
